export type ValidationFunction<T> = (value: T) => string | undefined

export function validateMinLength(msg: string, min: number, s: string) {
  if (s.length < min) return msg
}

export function validateLengthInRange(
  msg: string,
  min: number,
  max: number,
  s: string
) {
  const len = s.trim().length
  if (len < min || len > max) return msg
}

export function validateRegexp(msg: string, regexp: RegExp, s: string) {
  if (!regexp.test(s)) return msg
}

export function validateNoLeadingSpaces(msg: string, s: string) {
  return validateRegexp(msg, /^\S/, s)
}

export function composeValidations<T>(...fns: ValidationFunction<T>[]) {
  return function (value: T) {
    for (const fn of fns) {
      const msg = fn(value)
      if (msg) return msg
    }
  }
}
